// extracted by mini-css-extract-plugin
module.exports = {"link":"_6bf55ce5dc--link--zJkTL","link-name":"_6bf55ce5dc--link-name--kqq1p"};